/* eslint-disable react/require-optimization */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import TextInput from "./TextInput";
import WizardFooter from "./WizardFooter";
export const fields = [
  "snap_six_months",
  "tanf_three_years",
  "snap_one_year",
  "benefits_recipient",
  "benefits_city_and_state",
];

const validate = (values, props) => {
  const errors = {};
  if (
    !(
      values.snap_six_months === "no" &&
      values.tanf_three_years === "no" &&
      values.snap_one_year === "no"
    )
  ) {
    if (!values.benefits_recipient) {
      errors.benefits_recipient = props.allText.shared.required;
    }
    if (!values.benefits_city_and_state) {
      errors.benefits_city_and_state = props.allText.shared.required;
    }
  }
  return errors;
};

export class WizardFormSection09b extends Component {
  componentDidMount() {
    if (
      this.props.fields.snap_six_months.value === "no" &&
      this.props.fields.tanf_three_years.value === "no" &&
      this.props.fields.snap_one_year.value === "no"
    ) {
      this.props.handleSubmit();
    }
  }

  render() {
    const {
      allText,
      fields: { benefits_recipient, benefits_city_and_state },
      handleSubmit,
      previousPage,
    } = this.props;
    const text = { ...allText.shared, ...allText.section09b };
    const progress = 8;
    return (
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content">
          <div className="page-title-container">
            <span className="page-title underline">{text.title}</span>
            <span className="wizard-text question-text">{text.subtitle}</span>
          </div>
          <div>
            <div className="primary-question">{text.primaryQuestion}</div>

            <div className="separator" />

            <div className="row nine-b-last-question">
              <div className="col-12 col-sm-6">
                <div className="wizard-text">{text.question01}</div>
                <TextInput
                  text={text}
                  field={benefits_recipient}
                  placeholder={text.question01Placeholder}
                />
              </div>

              <div className="col-12 col-sm-6">
                <div className="wizard-text small-question">
                  {text.question02}
                </div>
                <TextInput
                  text={text}
                  field={benefits_city_and_state}
                  placeholder={text.question02Placeholder}
                />
              </div>
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          previousPage={previousPage}
          progress={progress}
        />
      </form>
    );
  }
}

WizardFormSection09b.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection09b);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection09b.js